export const REQUEST_STATE = 'REQUEST_STATE';
export const SET_ERROR = 'SET_ERROR';
export const SET_LOADING = 'SET_LOADING';

export const LOGOUT = 'LOGOUT';
export const CORE_GET_USERS_REQUEST = 'CORE_GET_USERS_REQUEST';
export const CORE_GET_USERS_SUCCESS = 'CORE_GET_USERS_SUCCESS';
export const CORE_GET_USERS_FAILURE = 'CORE_GET_USERS_FAILURE';

export const CORE_GET_USER_INFO_REQUEST = 'CORE_GET_USER_INFO_REQUEST';
export const CORE_GET_USER_INFO_SUCCESS = 'CORE_GET_USER_INFO_SUCCESS';
export const CORE_GET_USER_INFO_FAILURE = 'CORE_GET_USER_INFO_FAILURE';

export const CORE_CHANGE_USER_NPI_PERMIT_REQUEST = 'CORE_CHANGE_USER_NPI_PERMIT_REQUEST';
export const CORE_CHANGE_USER_NPI_PERMIT_SUCCESS = 'CORE_CHANGE_USER_NPI_PERMIT_SUCCESS';
export const CORE_CHANGE_USER_NPI_PERMIT_FAILURE = 'CORE_CHANGE_USER_NPI_PERMIT_FAILURE';

export const CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST = 'CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST';
export const CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS = 'CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS';
export const CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE = 'CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE';

//AUTH
export const CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST';
export const CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS';
export const CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE';

export const CORE_GET_REQUEST_INFO_REQUEST = 'CORE_GET_REQUEST_INFO_REQUEST';
export const CORE_GET_REQUEST_INFO_SUCCESS = 'CORE_GET_REQUEST_INFO_SUCCESS';
export const CORE_GET_REQUEST_INFO_FAILURE = 'CORE_GET_REQUEST_INFO_FAILURE';

//Domain
export const CORE_GET_ALL_DOMAIN_REQUEST = 'CORE_GET_ALL_DOMAIN_REQUEST';
export const CORE_GET_ALL_DOMAIN_SUCCESS = 'CORE_GET_ALL_DOMAIN_SUCCESS';
export const CORE_GET_ALL_DOMAIN_FAILURE = 'CORE_GET_ALL_DOMAIN_FAILURE';

export const CORE_CREATE_DOMAIN_REQUEST = 'CORE_CREATE_DOMAIN_REQUEST';
export const CORE_CREATE_DOMAIN_SUCCESS = 'CORE_CREATE_DOMAIN_SUCCESS';
export const CORE_CREATE_DOMAIN_FAILURE = 'CORE_CREATE_DOMAIN_FAILURE';

export const CORE_GET_DOMAIN_ID_REQUEST = 'CORE_GET_DOMAIN_ID_REQUEST';
export const CORE_GET_DOMAIN_ID_SUCCESS = 'CORE_GET_DOMAIN_ID_SUCCESS';
export const CORE_GET_DOMAIN_ID_FAILURE = 'CORE_GET_DOMAIN_ID_FAILURE';

export const CORE_UPDATE_DOMAIN_REQUEST = 'CORE_UPDATE_DOMAIN_REQUEST';
export const CORE_UPDATE_DOMAIN_SUCCESS = 'CORE_UPDATE_DOMAIN_SUCCESS';
export const CORE_UPDATE_DOMAIN_FAILURE = 'CORE_UPDATE_DOMAIN_FAILURE';

export const CORE_GET_CHANGE_EXPIRE_REQUEST = 'CORE_UPDATE_DOMAIN_REQUEST';
export const CORE_GET_CHANGE_EXPIRE_SUCCESS = 'CORE_GET_CHANGE_EXPIRE_SUCCESS';
export const CORE_GET_CHANGE_EXPIRE_FAILURE = 'CORE_GET_CHANGE_EXPIRE_FAILURE';



// WEBPACK FOOTER //
// ./src/app/redux/types.js